import React from 'react'
import styles from './Hero.css';

const Hero = () => {
    return (
      <div className={styles.image} >
        <div className={styles.title}>Osaka</div>
        <div className={styles.subtitle}> Sushi Bar </div>
      </div>
    )
  }


export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero/Hero.js